import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar } from '../../components/Avatar';
import { Content, ContentWrapper } from '../../components/Content';
import * as Styled from './AccountTypes.styles';
import { accountTypes as accountTypesData } from './data';

const AccountTypes = () => {
  const { t } = useTranslation();

  const accountTypes = useMemo(
    () =>
      accountTypesData.map((type) => ({
        ...type,
        name: t(`homeAccountTypes.types.${type.key}`),
        img: {
          ...type.img,
          alt: t(`homeAccountTypes.imgAlt.${type.key}`),
        },
      })),
    [t],
  );

  // const getImgVariants = (index) => {
  //   const isOdd = index % 2 === 0;

  //   return {
  //     initial: {
  //       x: 40,
  //       y: '-49%',
  //       opacity: 0,
  //       rotate: 0,
  //     },
  //     hover: {
  //       x: 0,
  //       y: '-47%',
  //       opacity: 1,
  //       rotate: isOdd ? 12 : -12,
  //       transition: { duration: 0.35, ease: [0.25, 0.1, 0.25, 1] },
  //     },
  //   };
  // };

  return (
    <Styled.AccountTypes id="account-types">
      <ContentWrapper>
        <Content
          labels={[t('homeAccountTypes.label')]}
          title={t('homeAccountTypes.title')}
        />

        <Styled.Types>
          {accountTypes.map((accountType) => {
            return (
              <Styled.Type
                key={accountType.key}
                initial="initial"
                whileHover="hover"
              >
                <Styled.Content>
                  <Avatar size="lg" icon={accountType.icon} />

                  <Styled.Line variant="h4" className="line">
                    /
                  </Styled.Line>

                  <Styled.Name variant="h4" className="name">
                    {accountType.name}
                  </Styled.Name>
                </Styled.Content>

                {/* <Styled.Arrow variant="arrowRight" className="arrow" /> */}

                {/* <Styled.Img
                  src={accountType.img.src}
                  alt={accountType.img.alt}
                  variants={getImgVariants(index)}
                /> */}
              </Styled.Type>
            );
          })}
        </Styled.Types>
      </ContentWrapper>
    </Styled.AccountTypes>
  );
};

export default AccountTypes;
